import { render, staticRenderFns } from "./ShopWearParts.vue?vue&type=template&id=683f6bd0&scoped=true"
import script from "./ShopWearParts.vue?vue&type=script&lang=js"
export * from "./ShopWearParts.vue?vue&type=script&lang=js"
import style0 from "./ShopWearParts.vue?vue&type=style&index=0&id=683f6bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f6bd0",
  null
  
)

export default component.exports